module.exports = __webpack_public_path__ + "img/prime-video.58e7f107.png";